<template>
  <div class="head-info">
    <span>{{ title }}</span>
    <p>{{ content }}</p>
    <a-button
      v-if="showBtn"
      type="link"
      @click="handleClick"
    >{{ btnText }}</a-button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HeadInfo',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: [String, Number],
      default: ''
    },
    showBtn: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: '查看'
    }
  },
  methods: {
    handleClick() {
      this.$emit('tapbtn')
    }
  }
}
</script>

<style lang="less" scoped>
.head-info {
  text-align: center;
  padding: 20px;
  flex-grow: 1;
  flex-shrink: 0;
  // align-self: center;
  span {
    color: @text-color-secondary;
    display: inline-block;
    font-size: 14px;
    margin-bottom: 4px;
  }
  p {
    color: @text-color;
    font-size: 24px;
    margin: 0;
  }
}
</style>
